import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BaseButton = styled.button`
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#003232')};
  color: ${(props) => (props.color ? props.color : '#fff')};
  font-weight: ${(props) => (props.weight ? props.weight : '0')};
  border-radius: 5px;
  width: ${(props) => (props.width ? props.width : 'auto')};
  height: ${(props) => (props.height ? props.height : '50px')};
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: ${(props) => (props.mt ? props.mt : '0.5em')};
  margin-bottom: ${(props) => (props.mb ? props.mb : '0.5em')};
  margin-left: ${(props) => (props.ml ? props.ml : '0')};
  margin-right: ${(props) => (props.mr ? props.mr : '0')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  border: ${(props) => (props.border ? props.border : 'none')};
  cursor: pointer;
  padding: 1rem 2rem;

  &:disabled {
    background: #d4e7e7;
  }
  img {
    margin-right: 1rem;
  }

  @media screen and (max-width: 992px) {
    font-size: 16px;
    width: 100%;
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    font-size: 20px;
  }
`;

export const Button = ({ icon, text, onClick, ...props }) => {
  return (
    <BaseButton onClick={onClick} {...props}>
      {icon && <img src={icon} alt={icon} />}
      <> {text} </>
    </BaseButton>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  onClick: () => {},
  icon: '',
};
